// Also add to data-mapper-transform-functions.ts
export enum TransformFunctionType {
	Trim = 0,
	TrimStart = 1,
	TrimEnd = 2,
	Replace = 3,
	ToUpperCase = 4,
	ToLowerCase = 5,
	AddPrefix = 6,
	AddSuffix = 7,
	Combine = 18,
	Substring = 30,
	StringToNum = 21,
	StringToDatetime = 22,
	StringToObject = 24,
	Add = 9,
	Subtract = 10,
	Multiply = 11,
	Divide = 12,
	NumToString = 20,
	RoundUp = 25,
	RoundDown = 26,
	MathFloor = 27,
	MathCeil = 28,
	AddTime = 13,
	SubtractTime = 14,
	DatetimeToString = 23,
	AddField = 16,
	RemoveField = 17,
	ObjectToString = 29,
}
